import React from 'react';
import { Media } from '../../../utils';
import { Card } from './Card/Card';
import { Table } from './Table/Table';

export enum TableRowType {
  text = 'text',
  icon = 'icon',
  button = 'button',
}

export interface MktSwitcherTabTableHeaderProps {
  title: string;
  dataIndex: string;
  primary?: boolean;
  type?: `${TableRowType}`;
  actionIndex?: string;
}

export interface TableRowContent {
  type: `${TableRowType}`;
  label: string;
  linkUrl?: string;
  iconUrl?: string;
}

export interface MktSwitcherTabTableRowProps {
  [key: string]: TableRowContent;
}

export interface MktSwitcherTabTableProps {
  rows?: MktSwitcherTabTableRowProps[];
  header?: MktSwitcherTabTableHeaderProps[];
  isLoading?: boolean;
}

export const MktSwitcherTabTable: React.FC<MktSwitcherTabTableProps> = ({
  header,
  rows,
  isLoading,
}) => {
  const isDesktop = Media().lg();

  if (!isDesktop) {
    return (
      <div className="whl-mx-4 whl-flex whl-flex-col whl-gap-2">
        {isLoading ? (
          <Card isLoading={isLoading} row={undefined} header={undefined} />
        ) : (
          rows?.map((row, i) => {
            return (
              <Card row={row} header={header} key={i} isLoading={isLoading} />
            );
          })
        )}
      </div>
    );
  }

  return (
    <div className="whl-mx-5">
      <Table rows={rows} header={header} isLoading={isLoading} />
    </div>
  );
};
